import { httpService } from "./httpService";

/**
 * Live dispatch snapshot — every driver in tenant with last known position
 * and currently-active ride (if any).
 */
export const getLiveDrivers = async () =>
  httpService({ url: "/dispatch/drivers", options: { method: "GET" } });

/**
 * Rides stuck in DECLINED / TIMED_OUT / UNMATCHED — auto-reassign exhausted,
 * needs a dispatcher to reassign manually or cancel.
 */
export const getNeedsAttentionRides = async () =>
  httpService({ url: "/dispatch/needs-attention", options: { method: "GET" } });
